// CriarContaPage.js — Rota /criar-conta. Somente CADASTRO.
// Depois de criar a conta por e-mail/senha, a mesma página passa para a etapa
// de confirmação do código; pelo Google não há código (o e-mail já vem
// verificado pelo próprio Google).
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import useDestinoAposEntrar from "./destinoAposEntrar";
import { FormCriarConta, FormVerificarEmail, FormCompletarTelefone } from "./AuthForms";

const main = process.env.REACT_APP_MAIN;

const CriarContaPage = () => {
  const { state } = useLocation();
  const [emailParaVerificar, setEmailParaVerificar] = useState(null);
  const [pedirTelefone, setPedirTelefone] = useState(false);

  // Volta para onde a pessoa estava indo — rota e aba. Ver destinoAposEntrar.js.
  const concluir = useDestinoAposEntrar();

  if (emailParaVerificar) {
    return (
      <AuthLayout titulo="Quase lá!">
        <FormVerificarEmail email={emailParaVerificar} onSucesso={concluir} />
      </AuthLayout>
    );
  }

  // O caminho do Google não passa pelo código de 6 dígitos (o e-mail já vem
  // verificado), mas passa por aqui: a conta nasce sem telefone e o número é o
  // único jeito de a editora falar com quem comprou. Os dois estados nunca
  // coexistem — um vem do cadastro por e-mail, o outro do login social.
  if (pedirTelefone) {
    return (
      <AuthLayout titulo="Quase lá!">
        <FormCompletarTelefone onConcluir={concluir} />
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      titulo="Criar sua conta"
      subtitulo="Leva menos de um minuto. É grátis."
      rodape={
        <>
          Já tem uma conta?{" "}
          <Link to={main + "login"} state={state} className="link-sublinhado text-insigne-orange font-semibold">
            Entrar
          </Link>
        </>
      }
    >
      <FormCriarConta
        onSucesso={concluir}
        onPrecisaVerificar={setEmailParaVerificar}
        onPrecisaTelefone={() => setPedirTelefone(true)}
      />
    </AuthLayout>
  );
};

export default CriarContaPage;
